import React from 'react';
import { FormattedMessage } from 'react-intl';
export const initialErrors = {
    name: '',
    surname: '',
    email: '',
    checkInDate: '',
    checkOutDate: '',
};
export const validateRequired = (value) => value.trim().length > 0;
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
export const validateField = (fieldName, value) => {
    switch (fieldName) {
        case 'name':
        case 'surname':
        case 'checkInDate':
        case 'checkOutDate':
            if (!validateRequired(value)) {
                return (React.createElement(FormattedMessage, { id: "bf.fieldRequired", defaultMessage: "bf.fieldRequired" }));
            }
            break;
        case 'email':
            if (!validateRequired(value)) {
                return (React.createElement(FormattedMessage, { id: "bf.fieldRequired", defaultMessage: "bf.fieldRequired" }));
            }
            else if (!validateEmail(value)) {
                return (React.createElement(FormattedMessage, { id: "cc.reservation.filter.email.error", defaultMessage: "cc.reservation.filter.email.error" }));
            }
            break;
    }
    return '';
};
export const validateForm = (formData) => {
    const errors = Object.assign({}, initialErrors);
    errors.name = validateField('name', formData.name);
    errors.surname = validateField('surname', formData.surname);
    errors.email = validateField('email', formData.email);
    errors.checkInDate = validateField('checkInDate', formData.checkInDate);
    errors.checkOutDate = validateField('checkOutDate', formData.checkOutDate);
    return errors;
};
export const isFormValid = (errors) => Object.values(errors).every(error => error === '');
